import Vue from 'vue'

const eventbus = new Vue()
export { eventbus as default }
